<template>
  <div id="app" class="app">
    <div class="app__inner">
      <preview />
      <div class="app__cursor">
        <about />
        <price />

        <img src="img/cap.png" class="app__cap" />

        <div class="app__footer">
          <div class="app__footer-inner">
            <img src="img/footer.avif" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preview from "@/components/Preview.vue";
import About from "@/components/About.vue";
import Price from "@/components/Price.vue";

export default {
  name: "app",
  components: {
    Preview,
    About,
    Price,
  },
  mounted() {
    const el = document.querySelector(".app__cursor");
    const cap = document.querySelector(".app__cap");
    el.addEventListener("mousemove", (event) => {
      cap.style.opacity = 1;
      cap.style.left = event.pageX + 10 + "px";
      cap.style.top = event.pageY + 10 + "px";
    });
  },
};
</script>

<style lang="scss">
@import "~@/assets/style/index.scss";
@import "~@/assets/style/responsive.scss";

.app {
  &__cursor {
    // position: relative;
  }
  &__cap {
    width: 139px;
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 2;

    @include for-mobile {
      display: none;
    }
  }

  &__footer {
    height: 370px;
    position: relative;

    @include for-mobile {
      height: 200px;
    }

    &-inner {
      position: absolute;
      border-radius: inherit;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        object-position: center;
        object-fit: cover;
        image-rendering: auto;
      }
    }
  }
}
</style>